const DEV_ROOT = "http://localhost:3002/";
export const PROD_ROOT = "https://prinx-api-d0a38bd400c2.herokuapp.com/";
const STAGE_ROOT = "https://prinx-api-d0a38bd400c2.herokuapp.com/";

import { REACT_APP_ENV } from "env";

const determineRoot = () => {
  if (REACT_APP_ENV == "production") return PROD_ROOT;
  if (REACT_APP_ENV == "pre_production") return PROD_ROOT;
  if (REACT_APP_ENV == "staging") return STAGE_ROOT;
  if (REACT_APP_ENV == "ALPHA") return PROD_ROOT;
  if (REACT_APP_ENV == "development") return DEV_ROOT;
  return PROD_ROOT;
};

export const ROOT = determineRoot();

import { getAccessToken } from "@privy-io/react-auth";

//Admin Calls
import { checkIfUserIsAdmin, getUsersWithCoin, burnNFT, toggleTokenLive, getUsers } from "./adminCalls";
export { checkIfUserIsAdmin, getUsersWithCoin, burnNFT, toggleTokenLive, getUsers };
import {
  checkGeolocation,
  fetchAssets,
  joinWaitlist,
  sendContactMessage,
  writeUserSelfAttestation,
  setUserHasDeposited,
  recordHeartbeat,
  recordUserCompanyBalancesAsSnapshot
} from "./prinxCalls";

export {
  checkGeolocation,
  fetchAssets,
  joinWaitlist,
  sendContactMessage,
  writeUserSelfAttestation,
  setUserHasDeposited,
  recordHeartbeat,
  recordUserCompanyBalancesAsSnapshot
};
import { getPlaidToken, saveIDVSessionToUser } from "./plaidCalls";
export { getPlaidToken, saveIDVSessionToUser };
// NO SECURITY
// Anyone Can call these
// NO SECURITY

// THESE FUNCTIONS SHOULD ONLY WORK FOR CALLER
// IE ONE USER SHOULD NOT BE ABLE TO GET ANOTHER USER DATA
// THESE FUNCTIONS SHOULD ONLY WORK FOR CALLER
export async function getCoinbaseCountries() {
  const privyToken = await getAccessToken();

  return fetch(`${ROOT}coinbase-countries`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json", // Specify the content type
      Authorization: `Bearer ${privyToken}` // ✅ Send Privy JWT
    }
  })
    .then((response) => response.json())
    .then((json) => json)
    .catch((error) => console.error(error));
}

export async function writeNewUserQuestionnaire(user: any, answers: object) {
  const privyToken = await getAccessToken();
  return fetch(`${ROOT}users/${user.id}/questionnaire`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${privyToken}`
    },
    body: JSON.stringify({ ...user, answers }) // Convert the data to a JSON string
  })
    .then((response) => response.json())
    .then((json) => {
      console.log(json);
      return json;
    })
    .catch((error) => {
      console.error("Submit Attestation Problem:", error);
      throw error; // Re-throw the error to be caught by the caller
    });
}

export async function encodeSwap(tokenIn: string, tokenOut: string, amountIn: string, action: string) {
  const privyToken = await getAccessToken();
  return fetch(`${ROOT}swap/encode`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${privyToken}`
    },
    body: JSON.stringify({ tokenIn, tokenOut, amountIn, action }) // Convert the data to a JSON string
  })
    .then((response) => response.json())
    .then((json) => {
      console.log(json);
      return json;
    })
    .catch((error) => {
      console.error("Swap Encode Error:", error);
      throw error; // Re-throw the error to be caught by the caller
    });
}

// this function gets prinx user from privy user object
// the reason for this is because we cannot modify the privy user object
// and we store other data, such as NFT id when whitelisted, attestation answers
// historical data, as well as holdings (basically a backup of blockchain)

export async function getPrinxUser(id: string) {
  if (!id) {
    console.warn("Attempting To Get Prinx User With Undefined Param -- Abandoning");
    return;
  }
  const privyToken = await getAccessToken();

  return fetch(`${ROOT}users/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json", // Specify the content type
      Authorization: `Bearer ${privyToken}` // ✅ Send Privy JWT
    }
  })
    .then((response) => response.json())
    .then((json) => json)
    .catch((error) => console.error(error));
}

//TODO this is wholly unnessary
// This http request returns the entire user which we already have
// then it gets sorted after... we could just use the function that gets sorted
// but ok
export async function getPortfolioData(smart_wallet: string) {
  if (!smart_wallet) {
    console.warn("Attempting To Get Prinx User With Undefined Param -- Abandoning");
    return;
  }
  const privyToken = await getAccessToken();

  return fetch(`${ROOT}portfolio/${smart_wallet}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json", // Specify the content type
      Authorization: `Bearer ${privyToken}` // ✅ Send Privy JWT
    }
  })
    .then((response) => response.json())
    .then((json) => {
      if (!json) return [];
      let source;
      if (REACT_APP_ENV === "staging") source = json.testHoldings;
      if (REACT_APP_ENV === "development") source = json.testHoldings;
      if (REACT_APP_ENV === "DEVELOPMENT") source = json.testHoldings;
      if (REACT_APP_ENV === "pre-production") source = json.holdings;
      if (REACT_APP_ENV === "production") source = json.holdings;
      //if something got messed up and source is undefined, default to live coins
      if (!source) source = json.holdings;
      const transformedHoldings = source.map((holding: any) => {
        // Calculate the sum of the `value` field in the items array
        const totalValue = holding.items.reduce((sum: number, item: any) => sum + item.value, 0);

        // Return a new object with `date` and the `value` sum
        return {
          date: new Date(holding.date), // Keep the original date
          price: totalValue // Summed value
        };
      });
      return transformedHoldings;
    })
    .catch((error) => console.error(error));
}
//record transaction after purchase has been made
// TODO Type Out data object here, don't remember what that is
export async function recordTransaction(data: object): Promise<void> {
  const privyToken = await getAccessToken();
  return fetch(`${ROOT}transactions/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json", // Specify the content type
      Authorization: `Bearer ${privyToken}` // ✅ Send Privy JWT
    },
    body: JSON.stringify(data) // Convert the data to a JSON string
  })
    .then((response) => response.json())
    .then((json) => {
      return json;
    })
    .catch((error) => {
      console.error("Failed to write user transaction", error);
    });
}

export async function getTransactions(smart_wallet: string) {
  const privyToken = await getAccessToken();
  return fetch(`${ROOT}transactions/${smart_wallet}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${privyToken}`
    }
  })
    .then((response) => response.json())
    .then((json) => {
      return json;
    })
    .catch((error) => {
      console.error("Error fetching transactions:", error);
      throw error;
    });
}

// ADMIN PRIVLEDGES REQUIRED
// send with bearer, obfuscated token
// ADMIN PRIVLEDGES REQUIRED

// offramp calls
export async function getSignedOnramperUrl(originalUrl: string): Promise<string | null> {
  try {
    const response = await fetch(`${ROOT}onramper-signature-request`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ url: originalUrl })
    });

    if (!response.ok) {
      console.error("Failed to get signed URL:", await response.text());
      return null;
    }

    const data = await response.json();
    return data.signedUrl;
  } catch (error) {
    console.error("Error fetching signed URL:", error);
    return null;
  }
}
export async function generateCDPToken(walletAddress: string, prinxUserId: string) {
  const requestBody = {
    sw: walletAddress,
    prinxUserId
  };

  try {
    const response = await fetch(`${ROOT}coinbase-token`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
        // Replace with your actual Coinbase API key or authorization token
      },
      body: JSON.stringify(requestBody)
    });

    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
    return null;
  }
}

export async function offrampCoins(prinxUserId: string) {
  try {
    const response = await fetch(`${ROOT}coinbase-sell-transaction`, {
      method: "POST",
      body: JSON.stringify({ prinxUserId: prinxUserId }),
      headers: {
        "Content-Type": "application/json"
        // Replace with your actual Coinbase API key or authorization token
      }
    });

    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
    return null;
  }
}
